// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"style__formWrapper__NMJwT","formTable":"style__formTable__wGnjp"};